const DEFAULT_API_ORIGIN = 'http://localhost:3000';
const API_PREFIX = '/api';

const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, '');

const ensureApiPrefix = (value: string) => {
  const normalizedValue = trimTrailingSlashes(value.trim());

  if (!normalizedValue) {
    return `${DEFAULT_API_ORIGIN}${API_PREFIX}`;
  }

  return normalizedValue.endsWith(API_PREFIX)
    ? normalizedValue
    : `${normalizedValue}${API_PREFIX}`;
};

export const apiConfigDefaults = {
  origin: DEFAULT_API_ORIGIN,
  prefix: API_PREFIX,
  baseUrl: `${DEFAULT_API_ORIGIN}${API_PREFIX}`,
} as const;

export const resolveApiBaseUrl = (apiUrl?: string) =>
  ensureApiPrefix(apiUrl ?? apiConfigDefaults.baseUrl);

export const resolveApiProxyTarget = (apiUrl?: string) => {
  const baseUrl = resolveApiBaseUrl(apiUrl);

  return baseUrl.endsWith(apiConfigDefaults.prefix)
    ? baseUrl.slice(0, -apiConfigDefaults.prefix.length)
    : baseUrl;
};

/**
 * Resolve uma URL de arquivo público (ex: /uploads/...) para uma URL absoluta
 * que funcione corretamente mesmo quando frontend e backend estão em origens
 * diferentes (ex: produção com domínios separados).
 *
 * - Se já for URL absoluta (http/https), retorna como está
 * - Se for caminho relativo (/uploads), concatena com a origem da API
 */
export const resolvePublicFileUrl = (maybeRelativeUrl?: string | null, apiUrl?: string): string => {
  if (!maybeRelativeUrl || typeof maybeRelativeUrl !== 'string') return '';
  const trimmed = maybeRelativeUrl.trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  const apiOrigin = resolveApiProxyTarget(apiUrl ?? import.meta.env.VITE_API_URL);
  const normalizedOrigin = trimTrailingSlashes(apiOrigin);
  const normalizedPath = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${normalizedOrigin}${normalizedPath}`;
};
